import axios from '../axios/interceptor';

export const getStaffMembers = async (businessId) => {
    const response = await axios.get(`/business/${businessId}/staff`);
    return response.data;
}

export const getStaffMembersWithRoles = async (businessId) => {
    const response = await axios.get(`/business/${businessId}/staff/roles`);
    return response.data;
}

export const addStaffMember = async (businessId, staffData) => {
    const response = await axios.post(`/business/${businessId}/staff`, staffData);
    return response.data;
}

export const updateStaffMember = async (businessId, staffId, staffData) => {
    const response = await axios.put(`/business/${businessId}/staff/${staffId}`, staffData);
    return response.data;
}